// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uGwc","inner":"Footer_inner__mNlre"};